export default "__VITE_ASSET__CbkL3JnN__"